<template>
  <div class="tt-icon tt-next-day-icon">
    <img src="@/assets/icons-new/clock-square.svg" alt="next-day">
    <div class="tt-tooltip">
      {{ $t('main_vpopup_next_day_tooltip') }}
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
@import "src/assets/styles-new/colors"
@import "src/assets/styles-new/vars"

.tt-next-day-icon
  position: absolute
  top: -10px
  left: -10px
  cursor: pointer
  &:hover
    .tt-tooltip
      display: block
</style>